module.exports = __webpack_public_path__ + "img/bug-fill.12b165a1.svg";